import { useMemo } from 'react';

import useMatch from './useMatch';
import useMatchHighlight from './useMatchHighlight';

import type { MatchUnitProps } from '.';

import type { Match } from '@shared-types/match.types';
import { MatchStatus } from '@shared-types/match.types';
import { getMatchTracking } from '@utilities/match-tracking';

export const useMatchTracking = (
  originalMatch: Match,
  options: MatchUnitProps['options'],
  disableTracking?: boolean,
) => {
  const match = useMatch(originalMatch);
  const isDomestic = match.competition?.region === 'DOMESTIC';
  const highlightsVideo = useMatchHighlight(
    match,
    !isDomestic && options.showHighlights && match.status === MatchStatus.FINISHED,
  );

  return useMemo(() => {
    if (disableTracking) return null;

    return getMatchTracking(match, !!highlightsVideo);
  }, [disableTracking, highlightsVideo, match]);
};
